import React, { memo, useCallback, useMemo } from 'react';
import { Formik } from 'formik';
import { prop, T, path } from 'ramda';
import PropTypes from 'prop-types';

import {
  KIND,
  CONTACT_KINDS,
  CONTACT_FORM_NAME,
  CONTACT_TITLE,
  ORGANIZATION_KINDS,
  SUB_OPTICIAN,
  CONTACTS,
  CONTACT_FORM_DESCRIPTION,
  useOrganizationActions,
  useAlerts,
} from 'store/organizations';
import Accordion from 'components/Accordion';

import MainForm from './MainForm';
import OpticianForm from './OpticianForm';
import DoctorForm from './DoctorForm';
import ReportsForm from './ReportsForm';
import { getInitValues, extractOpticianId } from './utils';
import { Text } from './styles';

const OrganizationForm = ({ organization }) => {
  const { updateOrganization } = useOrganizationActions();
  const { action, errors } = useAlerts(updateOrganization);
  const kind = prop(KIND, organization);

  const isNurseHome = kind === ORGANIZATION_KINDS.NURSING_HOME;
  const isClinic = kind === ORGANIZATION_KINDS.CLINIC;
  const initialValues = useMemo(() => getInitValues(organization), [organization]);

  const sendData = useCallback(
    (values) => {
      action({ ...values, [SUB_OPTICIAN]: extractOpticianId(values) });
    },
    [action]
  );

  return (
    <Formik initialValues={initialValues} validate={sendData} validateOnBlur={false}>
      {({ getFieldProps }) => (
        <>
          <Accordion label={CONTACT_TITLE[kind]} defaultOpen>
            <MainForm getFieldProps={getFieldProps} isNurseHome={isNurseHome} isClinic={isClinic} errors={errors} />
          </Accordion>
          {isNurseHome && (
            <Accordion label="Optiker">
              <OpticianForm />
            </Accordion>
          )}
          {CONTACT_KINDS[kind].map((type) => (
            <Accordion key={type} label={CONTACT_FORM_NAME[type]}>
              {isNurseHome && <Text>{CONTACT_FORM_DESCRIPTION[type]}</Text>}
              <DoctorForm
                getFieldProps={getFieldProps}
                type={type}
                isClinic={isClinic}
                errors={path([CONTACTS, type], errors || null)}
              />
            </Accordion>
          ))}
          {isNurseHome && (
            <Accordion label="Einstellungen">
              <ReportsForm />
            </Accordion>
          )}
        </>
      )}
    </Formik>
  );
};

OrganizationForm.propTypes = {
  organization: PropTypes.shape({}).isRequired,
};

export default memo(OrganizationForm, T);
